import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Door: React.FC<IconComponentProps> = ({
  className,
  strokeWidth = '1.5',
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.96094 8.23047C5.83581 8.23047 5.73438 8.12909 5.73438 8.00391C5.73438 7.87878 5.83581 7.77734 5.96094 7.77734"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
    <path
      d="M5.96094 8.23047C6.08607 8.23047 6.1875 8.12909 6.1875 8.00391C6.1875 7.87878 6.08607 7.77734 5.96094 7.77734"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
    <path
      d="M10.2656 2.5625H12.9844C13.2247 2.5625 13.4553 2.65798 13.6252 2.82793C13.7952 2.99789 13.8906 3.2284 13.8906 3.46875V12.5312C13.8906 12.7716 13.7952 13.0021 13.6252 13.1721C13.4553 13.342 13.2247 13.4375 12.9844 13.4375H10.2656"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.93354 14.7907L2.49607 14.0416C2.38775 14.0255 2.2889 13.9708 2.21782 13.8874C2.14673 13.8041 2.10822 13.6979 2.1094 13.5884V2.99737C2.11114 2.89532 2.14728 2.79683 2.21198 2.71788C2.27668 2.63893 2.36614 2.58414 2.46586 2.56237L7.90334 1.22113C7.96937 1.20671 8.03776 1.20724 8.10356 1.22268C8.16935 1.23812 8.23085 1.26808 8.2836 1.31037C8.33628 1.35265 8.37887 1.40619 8.40824 1.46706C8.43754 1.52793 8.45289 1.5946 8.45313 1.66217V14.3497C8.45313 14.4145 8.43899 14.4786 8.4118 14.5374C8.38455 14.5962 8.3448 14.6484 8.29538 14.6904C8.24596 14.7324 8.18802 14.7631 8.12555 14.7804C8.06302 14.7977 7.99752 14.8012 7.93354 14.7907Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
